"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchHistoryStore = exports.checkboxDefaults = void 0;
const matching_1 = require("@App/api/routes/rightsholder/matching");
const mobx_1 = require("mobx");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const recording_group_category_1 = __importDefault(require("@App/enum/recording-group-category"));
const recording_group_status_1 = require("@Components/MatchComponents/v2/recording-group-status");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
exports.checkboxDefaults = {
    SUBMITTED: false,
    ACCEPTED: false,
    PARTIALLY_ACCEPTED: false,
    REJECTED: false,
    IN_PROGRESS: false,
    SUPERSEDED: false,
    SORT_BY: 'last_updated_date',
};
class MatchHistoryStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchSuggestionHistory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchSuggestionHistoryFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.checkboxDefaults
        });
        Object.defineProperty(this, "_matchSuggestionHistoryPagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchSuggestionHistoryPaginationBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_PAGINATION_DEFAULT
        });
        Object.defineProperty(this, "_matchSuggestionHistoryResultsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_LIMIT_DEFAULT
        });
        Object.defineProperty(this, "_selectedMatchSuggestion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_recordingGroupsResultsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MatchHistoryStore.RECORDING_GROUP_RESULTS_LIMIT_DEFAULT
        });
        Object.defineProperty(this, "_recordingGroupsDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "_recordingGroupsDetailsPagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        (0, mobx_1.makeObservable)(this, {
            _matchSuggestionHistory: mobx_1.observable,
            _matchSuggestionHistoryFilter: mobx_1.observable,
            _selectedMatchSuggestion: mobx_1.observable,
            _recordingGroupsDetails: mobx_1.observable,
            setMatchSuggestionHistoryFilter: mobx_1.action,
            matchSuggestionHistoryFilterCount: mobx_1.computed,
            isDefaultPagination: mobx_1.computed,
            resetSelectedMatch: mobx_1.action,
            resetStore: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get matchSuggestionHistory() {
        return this._matchSuggestionHistory;
    }
    get matchSuggestionHistoryPagination() {
        return this._matchSuggestionHistoryPagination;
    }
    get matchSuggestionHistoryPaginationBody() {
        return this._matchSuggestionHistoryPaginationBody;
    }
    get matchSuggestionHistoryResultsLimit() {
        return this._matchSuggestionHistoryResultsLimit;
    }
    get selectedMatch() {
        return this._selectedMatchSuggestion;
    }
    get recordingGroupsDetails() {
        return this._recordingGroupsDetails;
    }
    get recordingGroupsDetailsPagination() {
        return this._recordingGroupsDetailsPagination;
    }
    get recordingGroupsResultsLimit() {
        return this._recordingGroupsResultsLimit;
    }
    get matchSuggestionHistoryFilter() {
        return this._matchSuggestionHistoryFilter;
    }
    get matchSuggestionHistoryFilterCount() {
        return Object.values(this._matchSuggestionHistoryFilter).filter((value) => value || typeof value === 'string')
            .length;
    }
    get isDefaultPagination() {
        return (this._matchSuggestionHistoryPaginationBody ===
            MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_PAGINATION_DEFAULT);
    }
    loadMatchSuggestionHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: This is 0-based pagination, but we use 1-based w/ PHP backend, what do?
            const paginationBody = this._matchSuggestionHistoryPaginationBody;
            const apiPagination = Object.assign(Object.assign({}, paginationBody), { page: paginationBody.page ? paginationBody.page - 1 : 0 });
            const statusFilters = Object.entries(this._matchSuggestionHistoryFilter)
                .filter(([key, value]) => value === true)
                .map(([key]) => key);
            const response = yield (0, matching_1.getMatchSuggestionHistory)(this.rootStore.rightsholderStore.currentRightsholderId, statusFilters, this._matchSuggestionHistoryFilter.SORT_BY, apiPagination);
            (0, mobx_1.runInAction)(() => {
                this._matchSuggestionHistory = response.data;
                this._matchSuggestionHistory.content = response.data.content.map((suggestion) => (Object.assign(Object.assign({}, suggestion), { getId: () => suggestion.suggestedMatchId })));
                this._matchSuggestionHistoryPagination = (0, calc_num_pages_1.calcNumPages)(response.data.totalElements, this._matchSuggestionHistoryResultsLimit, paginationBody.page ? paginationBody.page : 1, false);
            });
        });
    }
    setMatchSuggestionHistoryPaginationBody(body) {
        this._matchSuggestionHistoryPaginationBody = body;
    }
    setMatchSuggestionHistoryResultsLimit(newLimit) {
        const currentPagination = this.matchSuggestionHistoryPaginationBody;
        const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(currentPagination, this.matchSuggestionHistory.totalElements, newLimit, 0);
        this._matchSuggestionHistoryResultsLimit = newLimit;
        this.setMatchSuggestionHistoryPaginationBody(Object.assign(Object.assign({}, currentPagination), { limit: newLimit, page: newPage }));
    }
    setMatchSuggestionHistoryFilter(filters) {
        this._matchSuggestionHistoryFilter = filters;
    }
    loadSuggestedMatch(suggestionId) {
        return __awaiter(this, void 0, void 0, function* () {
            // check for existing match suggestion in the loaded data
            let found = this.matchSuggestionHistory &&
                this.matchSuggestionHistory.content.find((match) => match.suggestedMatchId === suggestionId);
            if (!found) {
                // if it hasn't been loaded yet, load it.
                const result = yield (0, matching_1.getMatchSuggestion)(this.rootStore.rightsholderStore.currentRightsholderId, suggestionId);
                found = result.data;
            }
            (0, mobx_1.runInAction)(() => {
                if (found) {
                    this._selectedMatchSuggestion = found;
                }
            });
        });
    }
    loadRecordingGroupDetails(submissionId, recordingGroupCategory, pagination) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: This is 0-based pagination, but we use 1-based w/ PHP backend, what do?
            const apiPagination = Object.assign(Object.assign({}, pagination), { page: pagination.page ? pagination.page - 1 : 0 });
            const recordingGroupStatus = [];
            switch (recordingGroupCategory) {
                case recording_group_category_1.default.Pending:
                    recordingGroupStatus.push(recording_group_status_1.RECORDING_GROUP_STATUS.SUBMITTED);
                    break;
                case recording_group_category_1.default.Accepted:
                    recordingGroupStatus.push(recording_group_status_1.RECORDING_GROUP_STATUS.ACCEPTED, recording_group_status_1.RECORDING_GROUP_STATUS.SUPERSEDED);
                    break;
                case recording_group_category_1.default.Rejected:
                    recordingGroupStatus.push(recording_group_status_1.RECORDING_GROUP_STATUS.REJECTED);
            }
            const response = yield (0, matching_1.getRecordingGroupsDetails)(this.rootStore.rightsholderStore.currentRightsholderId, submissionId, recordingGroupStatus, apiPagination);
            (0, mobx_1.runInAction)(() => {
                this._recordingGroupsDetails[recordingGroupCategory] = response.data;
                this._recordingGroupsDetailsPagination[recordingGroupCategory] = (0, calc_num_pages_1.calcNumPages)(response.data.totalElements, pagination.limit ? pagination.limit : MatchHistoryStore.RECORDING_GROUP_RESULTS_LIMIT_DEFAULT, pagination.page ? pagination.page : 0, false);
            });
        });
    }
    setRecordingGroupResultsLimit(limit) {
        this._recordingGroupsResultsLimit = limit;
    }
    resetSelectedMatch() {
        (0, mobx_1.runInAction)(() => {
            this._selectedMatchSuggestion = null;
            this._recordingGroupsDetails = {};
            this._recordingGroupsDetailsPagination = {};
        });
    }
    resetStore() {
        this.resetSelectedMatch();
        (0, mobx_1.runInAction)(() => {
            this._matchSuggestionHistory = {
                content: [],
                pageable: {
                    sort: { empty: true, unsorted: true, sorted: false },
                    offset: 0,
                    pageNumber: 0,
                    pageSize: 0,
                    paged: false,
                    unpaged: true,
                },
                last: true,
                totalPages: 0,
                totalElements: 0,
                sort: { empty: true, unsorted: true, sorted: false },
                first: true,
                number: 0,
                size: 0,
                numberOfElements: 0,
                empty: true,
            };
            this._matchSuggestionHistoryFilter = exports.checkboxDefaults;
            this._matchSuggestionHistoryPagination = { currentPage: 0, lastPage: 0 };
            this._matchSuggestionHistoryResultsLimit = MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_LIMIT_DEFAULT;
            this._matchSuggestionHistoryPaginationBody = MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_PAGINATION_DEFAULT;
            this._selectedMatchSuggestion = null;
            this._recordingGroupsResultsLimit = MatchHistoryStore.RECORDING_GROUP_RESULTS_LIMIT_DEFAULT;
            this._recordingGroupsDetails = {};
            this._recordingGroupsDetailsPagination = {};
        });
    }
}
exports.MatchHistoryStore = MatchHistoryStore;
Object.defineProperty(MatchHistoryStore, "SUGGESTION_HISTORY_RESULTS_LIMIT_DEFAULT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 10
});
Object.defineProperty(MatchHistoryStore, "SUGGESTION_HISTORY_RESULTS_PAGINATION_DEFAULT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        limit: MatchHistoryStore.SUGGESTION_HISTORY_RESULTS_LIMIT_DEFAULT,
        page: 1,
    }
});
Object.defineProperty(MatchHistoryStore, "RECORDING_GROUP_RESULTS_LIMIT_DEFAULT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 10
});
